import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=c25aa584&scoped=true"
import script from "./Vote.vue?vue&type=script&lang=js"
export * from "./Vote.vue?vue&type=script&lang=js"
import style0 from "./Vote.vue?vue&type=style&index=0&id=c25aa584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25aa584",
  null
  
)

export default component.exports